(function ($) {
 "use strict";

  jQuery(document).ready(function(){
    
/*----------------------------
 jQuery MeanMenu
------------------------------ */
	jQuery('nav#dropdown').meanmenu();	
	 
/*----------------------------
 owl active
------------------------------ */  
	$("#products-carousel").owlCarousel({
		autoPlay: false, 
		slideSpeed:1000,
		pagination:false,
		navigation:true,	  
		items : 4,
		navigationText:["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
		itemsDesktop : [1199,4],
		itemsDesktopSmall : [980,3],
		itemsTablet: [767,2],
		itemsMobile : [479,1],
	});
	
	$("#upsell-products-carousel").owlCarousel({
		autoPlay: false, 
		slideSpeed:1000,
		pagination:false,
		navigation:true,	  
		items : 4,
		navigationText:["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
		itemsDesktop : [1199,4],
		itemsDesktopSmall : [980,3],
		itemsTablet: [768,2],
		itemsMobile : [479,1],
	});
	
	$("#testimonial-carousel").owlCarousel({
		autoPlay: false, 
		slideSpeed:1000,
		pagination:true,
		navigation:false,	  
		singleItem:true,
		transitionStyle: "backSlide"
	});
	
    
/*----------------------------
 scroll-to-comment
-----------------------------*/   
    $("#show-comment").on('click', function(event) {

      event.preventDefault();

      var hash = this.hash;

      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 1000, function(){

        window.location.hash = hash;
        
      });
    });
    
/*--------------------------
 scrollUp
---------------------------- */	
	$.scrollUp({
        scrollText: '<i class="fa fa-angle-up"></i>',
        easingType: 'linear',
        scrollSpeed: 900,
        animation: 'fade',
		animationSpeed: 500
    }); 	   
 
    });
  
})(jQuery); 